import { updateFormData } from 'js/actions';
import { FORM_TYPE_CREATE_REUSABLE_TX as FormKey } from 'js/constants/formTypes';
import ReusableDocumentation from 'new/components/ReusableTransform/ReusableDocumentation';
import { TransformDataForm } from 'new/components/ReusableTransform/types';
import { useGetForm } from 'new/hooks/useGetForm';
import React, { ChangeEvent } from 'react';
import { useDispatch } from 'react-redux';
import { Form } from 'src/@types';
import './ReusableCore.scss';

export default function ReusableCoreHeader({ transformID }) {
  const dispatch = useDispatch();
  const form = useGetForm<Form<TransformDataForm>>(FormKey);
  const name = form?.data?.name ?? '';
  const description = form?.data?.description ?? '';

  const onChangeInput = (event: ChangeEvent<HTMLInputElement>) => {
    const { value, name } = event.target;
    dispatch(updateFormData(FormKey, { [name]: value }));
  };

  return (
    <div className="reusable-core-header">
      <div className="information">
        <div className="title-container">
          <input
            name="name"
            value={name}
            autoComplete="off"
            className="input-title"
            onChange={onChangeInput}
            placeholder="Draft – Untitled Transform"
          />
          <input
            value={description}
            name="description"
            autoComplete="off"
            className="input-description"
            onChange={onChangeInput}
            placeholder="Description"
          />
        </div>
      </div>
      <div className="doc">
        <ReusableDocumentation transformID={transformID} />
      </div>
    </div>
  );
}
